const certificates = {
	modulename: "Expertise",
	new_certificate: "Register expertise",
	edit_certificate: "Edit Expertise: {name}",
	view_certificate: "View Expertise: {name}",
	list_title: "List of Expertises",
	list_subtitle: "Manage Expertise",
	create_title: "Create New Expertise",
	update_title: "Update Expertise",
	address_title: "Address",
	details_title: "Certificate Details",
	id: "ID",
	title: "Title",
	company_name: "Certification company name",
	issued_date: "Issued date",
	issued_by: "Certificate issued by",
	issued_by_vat: "Certificate issued by company ID",
	course_name: "Course name",
	course_held_by: "Course held by",
	note: "Note",
	course_id: "Course",
	class_id: "Classes",
	participant_id: "Students",
	drivingtest_id: "Driving Test",
	attendee_id: "Attendee",
	documents: "Documents",
	filename: "Filename",
	mime: "Mime",
	path: "Path",
	size: "Size",
	deleted_on: "Deleted on",
	removed_on: "Removed on",
	created_at: "Date Created",
	upload_files: "Upload Documents",
	select_files: "Select files to upload",
	save_first: "Please save first the certificate before uploading documents.",
	title_tooltip: "Here you can register expertise that is coming from paper documents and/or expertise acquired at other learning organisations",
	add_title: "Add new title",
	new_title_required: "Please enter an additional title.",
	moduletemplates: "Modules",
	file_upload_note: "Note: Make sure to upload both sides of plastic card/expertise proof.",
};
export default certificates;